import { getFromWebAPi } from '@/services/messaging/fetchQuery';

export function getAlternativeBaseProducts(baseProductId) {
  return getFromWebAPi("Products/GetAlternativeBaseProducts?baseProductId=" + baseProductId);
}
